import GameUtil from "../utility/game_util";
import TimeManager from "./time_manager";
import { util } from "protobufjs";
import AppData from '../pacakge/public/const/app_data';
import * as CryptoJS from 'crypto-js';
import { resLoader } from "../framework/res/ResLoader";

const { ccclass } = cc._decorator;

class TextureCache {
    key: string
    spriteFrame: cc.SpriteFrame
    counts: number
    constructor() { }
}

class ReloadCache {
    key: string
    count: number
    constructor() { }
}

@ccclass
export default class TextureManager extends cc.Component {

    public static readonly instance: TextureManager = new TextureManager();

    spriteCache: TextureCache[] = []
    reloadCache: ReloadCache[] = []
    reloadTimeArray = [1, 3, 5]//加载失败后重新加载间隔时间

    clear() {
        let length = this.spriteCache.length
        for (let i = 0; i < length; i++) {
            cc.loader.releaseAsset(this.spriteCache[i].spriteFrame)
        }
        this.spriteCache = []
        this.reloadCache = []
    }

    //加载远程图片
    getSprite(key: string, success: Function) {
        let index = this.hasSprite(key)
        if (index >= 0) {
            let cache = this.spriteCache[index];
            cache.counts++;
            return success(cache.spriteFrame)
        }
        let self = this
        let url = key
        if (AppData.userHttps && cc.sys.isBrowser && key.indexOf("http:") >= 0) {
            url = key.replace("http:", "https:")
        }

        GameUtil.loadTexture(url, function (err, texture, blob) {
            if (texture) {
                let frame = new cc.SpriteFrame(texture)
                self.addSprite(key, frame)
                self.removeReloadCache(key)
                return success(frame, blob)
            } else {
                cc.warn("下载图片出错：", key)
                let time = self.getReloadTime(key)
                if (time > 0) {
                    TimeManager.instance.scheduleOnce(() => {
                        self.getSprite(key, success)
                    }, time)
                }
            }
        });

    }

    tryGetSpriteFromDisk(key: string, callback: (spriteFrame: cc.SpriteFrame) => void): boolean {
        let index = this.hasSprite(key)
        if (index >= 0) {
            callback(this.spriteCache[index].spriteFrame)
            return true
        }
        let self = this
        if (CC_JSB) {
            let dirPath = jsb.fileUtils.getWritablePath() + 'image'
            let md5 = CryptoJS.MD5(key)
            let fullPath = `${dirPath}/${md5}.png`
            if (jsb.fileUtils.isFileExist(fullPath)) {
                let bytes = jsb.fileUtils.getDataFromFile(fullPath)
                if (bytes && bytes.length > 0) {
                    var img = new Image();
                    let strinsdf = util.base64.encode(bytes, 0, bytes.length)
                    var base = "data:image/png;base64," + strinsdf;
                    img.src = base;
                    img.onload = function () {
                        var texture = new cc.Texture2D();
                        texture.initWithElement(img);
                        texture.handleLoadedTexture();
                        let frame = new cc.SpriteFrame(texture)
                        self.addSprite(key, frame)
                        self.removeReloadCache(key)
                        callback(frame)
                    }
                    return true
                }
            }

        }
        return false
    }


    saveAvatarSpriteToLocalDisk(url: string, textureBytes: Uint8Array): boolean {
        if (!CC_JSB) {
            return
        }
        if (!url || url == '' || !textureBytes || textureBytes.length == 0) {
            return false
        }
        let dirPath = jsb.fileUtils.getWritablePath() + 'image'
        if (!jsb.fileUtils.isDirectoryExist(dirPath)) {
            jsb.fileUtils.createDirectory(dirPath)
        }
        let md5 = CryptoJS.MD5(url)
        let fullPath = `${dirPath}/${md5}.png`
        let result = jsb.fileUtils.writeDataToFile(textureBytes, fullPath)
        return result
    }
    tryGetPathFromDisk(url: string): string {
        if (CC_JSB) {
            let dirPath = jsb.fileUtils.getWritablePath() + 'image'
            let md5 = CryptoJS.MD5(url)
            let fullPath = `${dirPath}/${md5}.png`
            if (jsb.fileUtils.isFileExist(fullPath)) {
                return fullPath
            }
            return ""
        }
        return ""
    }

    //优先从本地获取
    downloadImageFromUrlToLocalPath(url: string, callback: (path: string) => void) {
        let self = this
        let localPath = this.tryGetPathFromDisk(url)
        if (localPath != "") {
            callback(localPath)
            return 
        }
        GameUtil.loadTexture(url, function (err, texture, blob) {
            if (texture) {
                let r = self.saveAvatarSpriteToLocalDisk(url, blob)
                if (r) {
                    let dirPath = jsb.fileUtils.getWritablePath() + 'image'
                    let md5 = CryptoJS.MD5(url)
                    let fullPath = `${dirPath}/${md5}.png`
                    callback(fullPath)
                }else{
                    callback("")
                }
            } else {
                callback("")
            }
        });
        // this.getSprite(url, function (frame, blob) {
        //     let r = self.saveAvatarSpriteToLocalDisk(url, blob)
        //     if (r) {
        //         let dirPath = jsb.fileUtils.getWritablePath() + 'image'
        //         let md5 = CryptoJS.MD5(url)
        //         let fullPath = `${dirPath}/${md5}.png`
        //         callback(fullPath)
        //     }else{
        //         callback("")
        //     }
        // })
    }

    deleteAvatarSpriteFromLocalDisk(url: string) {
        if (!CC_JSB) {
            return
        }
        if (!url || url == '') {
            return
        }
        let dirPath = jsb.fileUtils.getWritablePath() + 'image'
        let md5 = CryptoJS.MD5(url)
        let fullPath = `${dirPath}/${md5}.png`
        if (jsb.fileUtils.isFileExist(fullPath)) {
            jsb.fileUtils.removeFile(fullPath)
        }
    }

    //加载本地图片
    getLocalSprite(name: string, success: Function) {
        let index = this.hasSprite(name)
        if (index >= 0) {
            return success(this.spriteCache[index].spriteFrame)
        }
        let self = this
        cc.loader.loadRes("image/" + name, cc.SpriteFrame, function (error: Error, resource) {
            if (error) {
                cc.log(error)
            } else {
                let frame = <cc.SpriteFrame>resource
                self.addSprite(name, frame)
                return success(frame)
            }
        })
    }

    hasSprite(key: string) {
        let length = this.spriteCache.length
        for (let i = 0; i < length; i++) {
            if (this.spriteCache[i].key == key) {
                return i
            }
        }
        return -1
    }

    addSprite(key: string, spriteFrame: cc.SpriteFrame) {
        let index = this.hasSprite(key)
        if (index < 0) {
            let spriteData = new TextureCache()
            spriteData.key = key
            spriteData.spriteFrame = spriteFrame
            spriteData.counts = 1;
            this.spriteCache.push(spriteData)
        } else {
            this.spriteCache[index].spriteFrame = spriteFrame
        }
    }

    clearSpriteCache() {
        return;
        //缓存计数最大值
        const MAX_CACHE = 10;
        if (this.spriteCache.length > MAX_CACHE) {
            //倒序
            this.spriteCache.sort((a, b) => {
                return b.counts - a.counts;
            });
            //只留1/10
            let startIndex = MAX_CACHE / 10;
            this.spriteCache.forEach((ele, index) => {
                if (index >= startIndex) {
                    ele.spriteFrame.clearTexture();
                }
            })
            this.spriteCache.splice(startIndex);
        }
    }

    hasReloadCache(key: string) {
        let length = this.reloadCache.length
        for (let i = 0; i < length; i++) {
            if (this.reloadCache[i].key == key) {
                return i
            }
        }
        return -1
    }

    removeReloadCache(key: string) {
        let index = this.hasReloadCache(key)
        if (index > 0) {
            this.reloadCache.splice(index, 1)
        }
    }

    getReloadTime(key: string) {
        let index = this.hasReloadCache(key)
        if (index < 0) {
            let spriteData = new ReloadCache()
            spriteData.key = key
            spriteData.count = 0
            this.reloadCache.push(spriteData)
            if (spriteData.count >= this.reloadTimeArray.length) {
                return -1
            } else {
                return this.reloadTimeArray[spriteData.count]
            }
        } else {
            let spriteData = this.reloadCache[index]
            spriteData.count = spriteData.count + 1
            if (spriteData.count >= this.reloadTimeArray.length) {
                return -1
            } else {
                return this.reloadTimeArray[spriteData.count]
            }
        }
    }
}